<style lang="scss">
.view-ban-modal {
  .reason-input {
    max-height: 100px;
    overflow-y: auto;
  }
}
</style>

<!-- eslint-disable -->
<template>
  <section class="view-ban-modal p-1">
    <h3 class="border-bottom pb-1 mb-1">Ban Details</h3>

    <section class="view-ban-modal__content pb-2 row">
      <section class="col-6 pb-0">
        <p class="font-weight-bolder mb-1">Visitor name</p>
        <p class="mb-0" cy="name" v-if="ban.visitor">{{ban.visitor.firstname}} {{ban.visitor.lastname}}</p>
        <p v-else>-</p>
      </section>

      <section class="col-6 pb-0">
        <p class="font-weight-bolder mb-1">Visitor email</p>
        <p v-if="ban.visitor" cy="email">{{ban.visitor.email}}</p>
        <p v-else>-</p>
      </section>

      <section class="col-6 pb-0">
        <p class="font-weight-bolder mb-1">Start date</p>
        <p class="mb-0" cy="start">{{ban.start_date}}</p>
      </section>

      <section class="col-6 pb-0">
        <p class="font-weight-bolder mb-1">End date</p>
        <p cy="end">{{ban.end_date}}</p>
      </section>

      <section class="col-6 pb-0">
        <p class="font-weight-bolder mb-1">Banned by</p>
        <p cy="banned">{{ban.banned_by}}</p>
      </section>

      <section class="col-12 pb-0">
        <p class="font-weight-bolder mb-1">Reason</p>
        <p cy="reason" class="reason-input">{{ban.reason}}</p>
      </section>
    </section>

    <b-btn variant="outline-primary" class="full-width" @click="$router.push({name: 'visitor-profile', params: {id: ban.user_id}})">
      Visitor Details
    </b-btn>
    <b-btn variant="primary" @click="$emit('close')" class="btn text-white full-width mt-2" elevation="0">Close</b-btn>
  </section>
</template>
<!-- eslint-enable -->

<script>
  export default {
    props: {
      ban: {
        type: Object,
        required: true,
      },
    },
    components: {},
    data() {
      return {
        test: '',
      };
    },
    mounted() {

    },
    methods: {

    },
  };
</script>
